module.exports = __webpack_public_path__ + "img/showcase.5742d705.png";